class MHeader extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      headers: ["header"],
      logos: [".m-logo"],
      topbar: ".m-topbar",
      headerWrapper: ".m-header__wrapper",
      topbarClose: ".m-topbar__close"
    };

    this.domNodes = queryDomNodes(this.selectors, this);
    this.innerWidth = window.innerWidth;

    this.stickyEnabled = this.dataset.sticky === "true";

    this.classes = {
      scrollUp: "scroll-up",
      scrollDown: "scroll-down",
      stuck: "stuck"
    };

    this.lastScroll = 0;
    this.ticking = false;

    this.init();
  }

  init() {
    this.transparentHeader =
      this.domNodes?.headers?.[0]?.dataset.transparent === "true";

    this.initAddon();

    // Delay layout reads until DOM is stable
    requestAnimationFrame(() => {
      this.headerHeight = this.domNodes.headerWrapper.offsetHeight;
      this.handleSticky();
    });

    document.addEventListener("matchMobile", () => this.handleSticky());
    document.addEventListener("unmatchMobile", () => this.handleSticky());

    window.addEventListener("resize", () => {
      this.innerWidth = window.innerWidth;
    });
  }

  initAddon() {
    this.megamenu = new Megamenu(this);

    if (Shopify.designMode) {
      MinimogTheme = MinimogTheme || {};
      MinimogTheme?.Wishlist?.updateWishlistCount();
    }
  }

  handleSticky() {
    if (!this.stickyEnabled) return;

    // READS FIRST (once)
    let offset = 20;

    document
      .querySelectorAll(".shopify-section-group-header-group")
      .forEach((el) => {
        if (!el.classList.contains("m-section-header")) {
          offset += el.offsetHeight;
        }
      });

    const topbar = document.querySelector(".m-topbar");
    if (topbar) offset += topbar.offsetHeight;

    window.addEventListener("scroll", () => {
      if (!this.ticking) {
        requestAnimationFrame(() => {
          const currentScroll = window.scrollY;

          if (currentScroll <= offset) {
            this.classList.remove(this.classes.scrollUp, this.classes.stuck);
          } else {
            this.classList.add(this.classes.stuck);

            if (
              currentScroll > this.headerHeight + offset &&
              currentScroll > this.lastScroll &&
              !this.classList.contains(this.classes.scrollDown)
            ) {
              this.classList.remove(this.classes.scrollUp);
              this.classList.add(this.classes.scrollDown);
            } else if (
              currentScroll < this.lastScroll &&
              this.classList.contains(this.classes.scrollDown)
            ) {
              this.classList.remove(this.classes.scrollDown);
              this.classList.add(this.classes.scrollUp);
            }
          }

          this.lastScroll = currentScroll;
          this.ticking = false;
        });

        this.ticking = true;
      }
    });
  }
}

customElements.define("m-header", MHeader);
